import { render, staticRenderFns } from "./RegularUser.vue?vue&type=template&id=68fc76fc&scoped=true&"
import script from "./RegularUser.vue?vue&type=script&lang=js&"
export * from "./RegularUser.vue?vue&type=script&lang=js&"
import style1 from "./RegularUser.vue?vue&type=style&index=1&id=68fc76fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc76fc",
  null
  
)

export default component.exports